import { render, staticRenderFns } from "./AlacakliOlduguDosyaTalepEvrakForm.vue?vue&type=template&id=13b87c35"
import script from "./AlacakliOlduguDosyaTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./AlacakliOlduguDosyaTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports